
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface Membership {
  id: string;
  name: string;
  slug: string;
}

interface AthleteOnlyMembershipCheckboxesProps {
  memberships: Membership[];
  selectedMembershipIds: string[];
  onSelectionChange: (membershipIds: string[]) => void;
}

const AthleteOnlyMembershipCheckboxes: React.FC<AthleteOnlyMembershipCheckboxesProps> = ({
  memberships,
  selectedMembershipIds,
  onSelectionChange
}) => {
  console.log('🏆 AthleteOnlyMembershipCheckboxes rendered with:', {
    memberships: memberships.length,
    selectedMembershipIds,
    membershipDetails: memberships.map(m => ({ id: m.id, name: m.name, slug: m.slug }))
  });
  
  const handleCheckboxChange = (membershipId: string, checked: boolean) => {
    console.log('✅ Checkbox changed:', { membershipId, checked });
    if (checked) {
      // Add membership
      onSelectionChange([...selectedMembershipIds, membershipId]);
    } else {
      // Remove membership
      onSelectionChange(selectedMembershipIds.filter(id => id !== membershipId));
    }
  };

  return (
    <div className="space-y-4">
      {/* Validation messages */}
      {selectedMembershipIds.length === 0 && (
        <p className="text-sm text-amber-600">⚠️ No memberships selected</p>
      )}
      
      {/* Checkbox list */}
      <div className="grid grid-cols-1 gap-3 max-h-40 overflow-y-auto">
        {memberships.map((membership) => {
          const isSelected = selectedMembershipIds.includes(membership.id);
          
          return (
            <div key={membership.id} className="flex items-center space-x-2">
              <Checkbox
                id={`membership-${membership.id}`}
                checked={isSelected}
                onCheckedChange={(checked) => handleCheckboxChange(membership.id, !!checked)}
              />
              <Label 
                htmlFor={`membership-${membership.id}`}
                className="text-sm flex flex-col"
              >
                <span className="font-medium">{membership.name}</span>
                <span className="text-xs text-muted-foreground">{membership.slug}</span>
              </Label>
            </div>
          );
        })}
      </div>
      
      {memberships.length === 0 && (
        <p className="text-sm text-muted-foreground">No athlete memberships available</p>
      )}
    </div>
  );
};

export default AthleteOnlyMembershipCheckboxes;
